const formTypes = {
    INDEX: "index",
    VIEW: "view",
    EDIT: "edit",
    ADD: "add"
};

export default formTypes;
